export default 'UA-7571492-12';



/** WEBPACK FOOTER **
 ** ./src/api/googleAnalytics.js
 **/